import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const rewardCatalogRoutes = [
	{
		key: "category-list",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/category-list`,
		component: React.lazy(() => import("views/reward-views/catalog/categories/pages/RewardCategoriesList")),
	},
	{
		key: "reward-product-list",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/product-list`,
		component: React.lazy(() => import("views/reward-views/catalog/products/pages/RewardProductList")),
	},
	{
		key: "reward-product-create",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/product`,
		component: React.lazy(() => import("views/reward-views/catalog/products/pages/RewardProductCreate")),
	},
	{
		key: "reward-product-detail",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/product/:id`,
		component: React.lazy(() => import("views/reward-views/catalog/products/pages/RewardProductEdit")),
	},
	{
		key: "reward-product-upload",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/product/upload`,
		component: React.lazy(() => import("views/reward-views/catalog/products/pages/RewardProductBulkUpload")),
	},
	{
		key: "reward-pricebook-list",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/pricebooks`,
		component: React.lazy(() => import("views/reward-views/catalog/pricebook/pages/PriceBookTabs")),
	},
	{
		key: "reward-pricebook-item-upload",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/pricebook/:id/upload`,
		component: React.lazy(() => import("views/reward-views/catalog/pricebook/pages/PriceBookItemUpload")),
	},
	{
		key: "reward-pricebook-create",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/pricebook/create`,
		component: React.lazy(() => import("views/reward-views/catalog/pricebook/pages/PriceBookCreate")),
	},
	{
		key: "reward-pricebook-detail",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/pricebook/:id`,
		component: React.lazy(() => import("views/reward-views/catalog/pricebook/pages/PriceBookInfo")),
	},
	{
		key: "reward-segment-pricebook-create",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/segment-pricebook/create`,
		component: React.lazy(() => import("views/reward-views/catalog/segmentPricebook/pages/SegmentPriceBookCreate")),
	},
	{
		key: "reward-segment-pricebook-item-upload",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/segment-pricebook/:id/upload`,
		component: React.lazy(() => import("views/reward-views/catalog/segmentPricebook/pages/SegmentPriceBookItemUpload")),
	},
	{
		key: "reward-segment-pricebook-detail",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/segment-pricebook/:id`,
		component: React.lazy(() => import("views/reward-views/catalog/segmentPricebook/pages/SegmentPriceBookInfo")),
	},
	{
		key: "catalog-item-min-dos",
		exact: true,
		path: `${APP_PREFIX_PATH}/catalogue/item-min-dos`,
		component: React.lazy(() => import("views/reward-views/catalog/item-min-dos/pages/ItemMinDosPage")),
	},
	{
		key: "reward-units-list",
		exact: true,
		path: `${APP_PREFIX_PATH}/reward/units`,
		component: React.lazy(() => import("views/reward-views/catalog/units/pages/UnitList")),
	},
];
